import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { UseQueryEventsParams, queryEvents } from "supabase/events";

export const useQueryEvents = (params: UseQueryEventsParams) => {
  const {
    title,
    isPaid,
    forChildren,
    startDate,
    endDate,
    page,
    perPage,
    publishedState,
    isMunicipality,
    userUid,
    madeByOrganizer,
  } = params;

  const { isLoading, isError, error, data } = useQuery({
    queryKey: [
      "events",
      {
        title,
        isPaid,
        forChildren,
        startDate,
        endDate,
        page,
        publishedState,
        isMunicipality,
        userUid,
        madeByOrganizer,
      },
    ],
    queryFn: () => {
      return queryEvents({
        title,
        isPaid,
        forChildren,
        startDate,
        endDate,
        page,
        perPage,
        publishedState,
        isMunicipality,
        userUid,
        madeByOrganizer,
      });
    },
    placeholderData: keepPreviousData,
  });

  return {
    isLoading,
    isError,
    error,
    count: data?.count,
    events: data?.events,
  };
};
